import i18n from '../../../i18n'

export const getLabelByProcesses = processes => {
    if (processes.publishing) return i18n.t('Publishing...')
    if (processes.saving) return i18n.t('Saving...')
    if (processes.autoSaving) return i18n.t('Autosaving...')
    return ''
}
